export default "__VITE_ASSET__BawgSOyO__"